import httpClient from "@/_shared/http-client";
import requestAdapter from "@/_shared/api-services/_requestAdapter";
import responseAdapter from '@/_shared/api-services/_responseAdapter';

import { objectHelper, httpHelper } from "@/_shared/utils";

const getProject = async (id = 1) => {
  let results = {};
  const url = new URL('/projects', process.env.BACKEND_URL);
  url.searchParams.set('id', id);
  await httpClient.get(url).then(({ data }) => {
    const { record } = data;
    results = responseAdapter.adaptProjectForm(record);
  });
  return results;
};

const getAllOpenProjects = async (page = 1) => {
  const url = `/projects/open?page=${page}`;
  const response = httpClient.get(url);
  return response;
};

const handleProject = async (body, deadline, httpMethod = 'post') => {
  body = objectHelper.createCopy(body);
  body = requestAdapter.adaptProjectForm(body);

  body = httpHelper.addDateField(body, httpMethod);
  body.deadline_datetime = deadline.value.toLocaleString('sv');
  body.deadline_type = deadline.type;
  console.log(JSON.stringify(body));
  const url = '/projects';
  const response = await httpClient[httpMethod](url, body).catch(({ response }) => {
    throw new Error(response.data.message)
  });
  return response;
};

export const projectService = {
  edit: (body, deadline) => handleProject(body, deadline, 'patch'),
  add: (body, deadline) => handleProject(body, deadline, 'post'),
  get: (id) => getProject(id),
  getAllOpen: (page) => getAllOpenProjects(page),
};



// WEBPACK FOOTER //
// ./src/_shared/api-services/projectService.js